/**
 * created by lei lei
 *手动检测
 */
import React, {Component} from 'react';
import {
    Button,
    DatePicker,
    Input,
    Select,
    Modal,
    Row,
    Col,
    Checkbox,
    TreeSelect,
    Icon,
    Tooltip,
    Pagination,
    Empty, Divider
} from "antd";
import {message} from "../../../sysManagement/utils/sysManagementUtils";
import * as utils from "../../../../utils";
import CustomTable, {TitleIcon} from "../../../components/customTable/CustomTable";
import ReactEcharts from "echarts-for-react";
import './ContentSecurity.css';
import * as Action from '../../actions/horizontalManagement';
import WeChatReview from "../../../components/weChatReview/WeChatReview";
import MicroBlogReview from "../../../components/microBlogReview/MicroBlogReview";
import TiktokReview from "../../../components/tiktokReview/TiktokReview";
import {Scrollbars} from "react-custom-scrollbars";
import $ from "jquery";
import BaseComponent from "../../../../base/BaseComponent";
import {uuid, filtion} from '../../../../utils';

const {RangePicker} = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const {Option} = Select;
const {Search} = Input;
const {TextArea} = Input;
export default class ManualDetection extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.Action = Action;
        this.state = {
            startDate: null,//开始时间
            endDate: null,//结束时间
            searchText: '',//搜索的文字
            //开始检测弹出窗的值
            visible: false,//检测入口
            content: '',//检测内容
            useThesaurus: false,//是否使用词库
            departAllList: [],//所有部门
            depart: undefined,//所属单位
            mediaList: [],//媒体数据源
            media: '0',//选择媒体
            rangeStatus: false,//是否使用范围
            createsTartTime: null,//开始时间
            createEndTime: null,//结束时间
            timeStatus: false,//是否限制时间
            //点击列表每一项查看检测结果
            resultStatus: false,//检测结果状态
            mediaType: 0,//媒体类型
            releaseStatus: 0,//发布状态
            resultDepart: 0,//检测结果的所属部门
            //--------------手动检测列表----
            page: 1,
            size: 10,
            dataSource: [],//列表数据源
            totalElements: 0,
            //检测结果---------
            taskId: '',
            resultContent: '',
            record: {},
            resultPage: 1,
            resultSize: 10,
            resultList: [],
            resultTotalElements: 0,
            //检测报告
            reportStatus: false,
            reportData: [],
            hideOnSinglePage: true,
            testing:1,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getSensitiveCheckTaskListQuery();  //获取列表
        this.getDeptAll();//获取所有部门
        this.getMediaByDepart();//开始检测获取媒体
    }

    render() {
        return (
            <div className={'ManualDetection'}>
                {this.renderScreen()}
                {this.renderConetnt()}
                {this.renderDetectionEntranceModal()}
                {this.renderResultModal()}
                {this.renderDetectionReport()}
                {/*// 微信预览*/}
                <WeChatReview ref={(WeChatReview) => {
                    this.WeChatReview = WeChatReview
                }}/>
                {/*微博预览*/}
                <MicroBlogReview ref={(MicroBlogReview) => {
                    this.MicroBlogReview = MicroBlogReview
                }}/>
                {/*抖音预览*/}
                <TiktokReview ref={(TiktokReview) => {
                    this.TiktokReview = TiktokReview
                }}/>
            </div>
        )
    }

    //渲染筛选条件
    renderScreen() {
        return (
            <div style={{padding: "10px 20px 0px 20px"}}>
                <div style={{float: 'left', paddingTop: 7}}>
                    <Button onClick={() => {
                        this.startDetection()
                    }} type="primary">开始检测</Button>
                </div>
                <div style={{float: 'left'}}>


                    <div style={{float: 'left'}}>
                        <div className={'ContenSecurityTitle'} style={{float: 'left'}}>检测时间</div>
                        <div style={{float: 'left', width: 210, lineHeight: '45px'}}>
                            <RangePicker
                                value={[this.state.startDate, this.state.endDate]}
                                format={dateFormat}
                                onChange={(date, dateString) => {
                                    this.state.startDate = date[0];
                                    this.state.endDate = date[1];
                                    this.state.page = 1;
                                    this.getSensitiveCheckTaskListQuery();
                                }}
                            /></div>
                    </div>

                </div>
                <div style={{float: 'left', paddingLeft: 20,}}>
                    <div style={{height: 32, marginTop: 6}}>
                        <Search className={'ContenSecurityContent'}
                                placeholder="请输入关键字"
                                enterButton="查询"
                                size="default"
                                value={this.state.searchText}
                                onChange={(e) => {
                                    this.setState({
                                        searchText: e.target.value
                                    });
                                }}
                                onSearch={value => {
                                    this.state.page = 1;
                                    this.getSensitiveCheckTaskListQuery();
                                }}
                        />
                    </div>
                </div>
                <div style={{float: 'left',}} className={'ContenSecurityTitle'}>
                    <Button onClick={() => {
                        this.revert()
                    }} type="primary">重置</Button>
                </div>
                <div style={{clear: 'both'}}/>
            </div>
        )
    }

    //渲染内容
    renderConetnt() {

        let titleKeyList =
            [{
                key: 'key',
                titleName: '序号',
                ellipsis: true,
                width: 60,
            }, {
                key: 'count',
                titleName: '危险数量',
                ellipsis: true,
            },
                {
                    key: 'checkWords',
                    titleName: '检测内容',
                    ellipsis: true,
                    render: (text, record, index) => {
                        let sensitiveWord = '';
                        record.checkWords && record.checkWords.length > 0 && record.checkWords.forEach((item, i) => {
                            sensitiveWord = sensitiveWord + item + (i === record.checkWords.length - 1 ? '' : '、')
                        });
                        return (
                            <div style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                display: "inline-block",
                                padding: "5px 0px"
                            }}>
                                {sensitiveWord}
                            </div>
                        )
                    }
                },
                {
                    key: 'allMedia',
                    titleName: '检测范围',
                    render: (text, record, index) => {
                        if (record.allMedia) {
                            return (
                                <div>全部单位-全部媒体</div>
                            )
                        } else {
                            let mediaNames = '';
                            record.mediaNames && record.mediaNames.length > 0 && record.mediaNames.forEach((item, i) => {
                                mediaNames = mediaNames + item + (i === record.mediaNames.length - 1 ? '' : '、')
                            });
                            return (
                                <div title={mediaNames} style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {mediaNames}
                                </div>
                            )
                        }

                    }
                },
                {
                    key: 'status',
                    titleName: '状态',
                    render: (text, record, index) => {
                        return (
                            <div>
                                {record.status === '已完成' ? '已完成' : <div>
                                    检索中 <Icon type="sync" spin/>
                                </div>}
                            </div>
                        )
                    }
                },
                {
                    key: 'noLimitTime',
                    titleName: '检测日期范围',
                    width: 300,
                    render: (text, record, index) => {
                        if (record.noLimitTime) {
                            return (
                                <div>不限制</div>
                            )
                        } else {
                            return (
                                <div>
                                    {record.from && record.to ? /\d{4}-\d{1,2}-\d{1,2}/g.exec(utils.formatDate(record.from)) + '~' + /\d{4}-\d{1,2}-\d{1,2}/g.exec(utils.formatDate(record.to)) : ''}
                                </div>
                            )
                        }

                    }
                },
                {
                    key: 'checkTime',
                    titleName: '检测时间',
                    render: (text, record, index) => {
                        return (
                            <div>
                                {record.checkTime ? utils.formatDate(record.checkTime) : ''}
                            </div>
                        )
                    }
                }];
        let height = window.innerHeight - 275;
        return (
            <div id={"manualDetection"} style={{padding: "0px 20px"}}>
                <Scrollbars
                    autoHeight
                    autoHide
                    autoHeightMax={height}
                >
                    <CustomTable
                        dataSource={this.state.dataSource}
                        titleKeyList={titleKeyList}
                        defineStyle={{paddingTop: 10, backgroundColor: "#fff"}}
                        pagination={false}
                        onRow={record => {
                            return {
                                onClick: event => {
                                    this.onClickItem(record)
                                }, // 点击行
                            };
                        }}
                        rowClassName='manual-detection-row'
                    /></Scrollbars>
                <Divider style={{display: this.state.dataSource.length ? "block" : "none"}}/>
                <div style={{
                    padding: "16px 10px",
                    display: "flex",
                    justifyContent: "flex-end",
                    backgroundColor: "#ffffff",
                    borderRadius: "0 0 5px 5px"
                }}>
                    <Pagination
                        onChange={(page, pageSize) => {
                            this.paginationChange(page, pageSize)
                        }}//页码改变回调
                        onShowSizeChange={(page, pageSize) => {
                            this.state.hideOnSinglePage = false;
                            this.paginationChange(page, pageSize)
                        }}//每页条数改变回调
                        defaultCurrent={1}
                        defaultPageSize={10}
                        total={this.state.totalElements}
                        showTotal={total => `共${total}条`}
                        current={this.state.page}
                        pageSize={this.state.size}
                        showSizeChanger
                        showQuickJumper
                        hideOnSinglePage={this.state.hideOnSinglePage}
                    />
                </div>
                <style>{`
                #manualDetection .ant-divider-horizontal{margin: 10px 0px 0px 0px;}
                #manualDetection .ant-table-tbody > tr{cursor: pointer;}
                `}</style>
            </div>
        )
    }

    //渲染点击开始检测后的检测入口弹出框
    renderDetectionEntranceModal() {
        return (
            <div>
                <Modal
                    title="检测入口"
                    visible={this.state.visible}
                    okText={'检测'}
                    maskClosable={false}
                    key={this.state.testing}
                    onOk={() => this.handleOk()}
                    onCancel={() => {
                        this.state.testing=uuid()
                        this.setState({})
                        this.onCancel()
                    }}
                    width={750}
                >
                    <div>
                        <Row>
                            <div style={{padding: 10}}>
                                <Col span={4}>
                                    <div className={'myMediaTitle'}>
                                        <span style={{color: "red"}}>*</span> 检测内容：</div>
                                </Col>
                                <Col span={20}>
                                    <TextArea placeholder={"请输入检测内容"} value={this.state.content} disabled={this.state.useThesaurus}
                                              onChange={(e) => {
                                                  this.setState({content: e.target.value})
                                              }}/>
                                    <div style={{float: 'left', marginTop: 10, paddingBottom: 10}}>
                                        <Checkbox checked={this.state.useThesaurus} onChange={() => {
                                            this.setState({useThesaurus: !this.state.useThesaurus})
                                        }}>使用系统词库</Checkbox>
                                    </div>
                                    <div style={{float: 'right', marginTop: 10}}>多个关键词请用 “ 、” 隔开</div>
                                    <div style={{clear: 'both'}}/>
                                </Col>

                            </div>
                        </Row>

                        <Row>
                            <div style={{padding: 10}}>
                                <Col span={4}>
                                    <div className={'myMediaTitle'}><span style={{color: "red"}}>*</span> 检测范围：</div>
                                </Col>
                                <Col span={8}>
                                    <Select className={'ContenSecurityContent'} disabled={this.state.rangeStatus}
                                            style={{width: '100%'}}
                                            placeholder={"请选择部门"}
                                            value={this.state.depart}
                                            onChange={(e) => {
                                                this.state.depart = e;
                                                //this.setState({})
                                                this.getMediaByDepart();
                                            }}>
                                        {this.state.departAllList.map((item, i) => {
                                            return (
                                                <Option key={i} value={item.id}>{item.name}</Option>
                                            )
                                        })}
                                    </Select>

                                </Col>
                                <Col span={8}>
                                    <TreeSelect
                                        disabled={this.state.depart ? this.state.rangeStatus : true}
                                        style={{width: '100%', marginLeft: 10}}
                                        value={(() => {
                                            return this.state.media
                                        })()}
                                        dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                                        treeDefaultExpandAll
                                        treeData={this.state.mediaList}
                                        onChange={(value) => {
                                            console.log(value)
                                            this.setState({media: value})
                                        }}
                                    />
                                </Col>
                                <Col span={4}>
                                    <div style={{marginLeft: 17, paddingTop: 5}}>
                                        <Checkbox checked={this.state.rangeStatus} onChange={(value) => {
                                            this.setState({rangeStatus: !this.state.rangeStatus})
                                        }}>不限范围</Checkbox>
                                    </div>
                                </Col>
                            </div>
                        </Row>
                        <Row>
                            <div style={{padding: 10}}>
                                <Col span={4}>
                                    <div className={'myMediaTitle'}><span style={{color: "red"}}>*</span> 内容创建日期：</div>
                                </Col>
                                <Col span={8}>
                                    <RangePicker disabled={this.state.timeStatus}
                                                 value={[this.state.createsTartTime, this.state.createEndTime]}
                                                 format={dateFormat}
                                                 onChange={(date, dateString) => {
                                                     this.state.createsTartTime = date[0];
                                                     this.state.createEndTime = date[1];
                                                     this.setState({})
                                                 }}
                                    />
                                </Col>

                                <Col span={4}>
                                    <div style={{paddingLeft: 10, paddingTop: 5}}>
                                        <Checkbox checked={this.state.timeStatus} onChange={(value) => {
                                            this.setState({timeStatus: !this.state.timeStatus})
                                        }}>不限时间</Checkbox>
                                    </div>
                                </Col>
                            </div>
                        </Row>
                    </div>
                </Modal>
            </div>
        )
    }

    getTitle(record){
        let title;
        let sensitiveWords = '';
        record.sensitiveWordList && record.sensitiveWordList.length > 0 && record.sensitiveWordList.forEach((item, i) => {
            sensitiveWords = sensitiveWords + item.oldStr + (i === record.sensitiveWordList.length - 1 ? '' : '、')
        });
        let signWords = sensitiveWords.split('、');
        if (signWords && signWords.length > 0) {
            title = filtion(signWords, "<div style='overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'>" + record.title + "</div>").value;
        }else{
            title ="<div style='overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'>" + record.title + "</div>";
        }
        return title;
    }

    //渲染检测结果弹出窗
    renderResultModal() {
        let titleKeyList =
            [{
                key: 'key',
                titleName: '序号',
                ellipsis: true,
                width: 60,
                render: (text, record, index) => {
                    return (
                        <div title={(index + 1) + (this.state.page - 1) * (this.state.size)} style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>
                            {(index + 1) + (this.state.page - 1) * (this.state.size)}
                        </div>
                    )
                }
            }, {
                key: 'title',
                titleName: '文章标题',
                ellipsis: true,
                width: 400,
                render: (text, record, index) => {
                    return (
                        <div title={record.title}
                             style={{cursor:'pointer'}}
                             dangerouslySetInnerHTML={{__html: this.getTitle(record)}} />
                    )
                }
            },
                {
                    key: 'mediaName',
                    titleName: '所属媒体',
                    ellipsis: true,
                },
                {
                    key: 'status',
                    titleName: '媒体类型',
                    render: (text, record, index) => {
                        let iconType = '';
                        let title = '';
                        if (record.mediaType === 2) {
                            iconType = 'weChat';
                            title = "公众号";
                        } else if (record.mediaType === 3) {
                            iconType = 'microBlog';
                            title = "微博";
                        } else if (record.mediaType === 5) {
                            iconType = 'tiktok';
                            title = "抖音";
                        }
                        return (<div>
                                <TitleIcon title={title} iconType={iconType}/>
                            </div>

                        )
                    }
                },
                {
                    key: 'deptName',
                    titleName: '所属部门',
                    align: 'left',
                    ellipsis: true,
                },
                {
                    key: 'sensitiveWordList',
                    titleName: '检测词',
                    render: (text, record, index) => {
                        let sensitiveWord = '';
                        record.sensitiveWordList && record.sensitiveWordList.length > 0 && record.sensitiveWordList.forEach((item, i) => {
                            sensitiveWord = sensitiveWord + item.oldStr + (i === record.sensitiveWordList.length - 1 ? '' : '、')
                        });
                        return (
                            <div title={sensitiveWord} style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>
                                {sensitiveWord}
                            </div>
                        )
                    }
                },
                {
                    key: 'account',
                    titleName: '账号',
                    ellipsis: true,
                },
            ];
        return (
            <Modal
                title="检测结果"
                visible={this.state.resultStatus}
                okText={'检测'}
                onOk={() => {
                }}
                onCancel={() => {
                    this.resultCancel()
                }}
                footer={<div>
                    <Button type="primary" onClick={() => {
                        this.detectionReport()
                    }}>检测报告</Button>
                    <Button type="primary" onClick={() => {
                        this.exportExcel()
                    }}>导出表格</Button>
                    <Button onClick={() => {
                        this.resultCancel()
                    }}>关闭</Button>
                </div>}
                width={1250}
            >

                <div style={{paddingTop: "0 10px 10px 10px"}}>
                    {this.renderModalScreen()}
                    <Scrollbars
                        autoHeight
                        autoHide
                        autoHeightMax={500}
                        ref={(scrollRef) => {
                            this.scrollRef = scrollRef
                        }}
                    >


                        <CustomTable
                            dataSource={this.state.resultList}
                            titleKeyList={titleKeyList}
                            //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                            pagination={false}
                            onRow={record => {
                                return {
                                    onClick: event => {
                                        this.onClickItemReview(record)
                                    }, // 点击行
                                };
                            }}
                            rowClassName='manual-detection-row'
                        />

                    </Scrollbars>
                    {this.state.resultList && this.state.resultList.length > 0 ?
                        <div style={{marginRight: 10, float: 'right'}}>
                            <Pagination
                                showQuickJumper
                                // defaultCurrent={2}
                                current={this.state.resultPage}
                                pageSize={this.state.resultSize}
                                total={this.state.resultTotalElements}
                                showTotal={total => `共 ${total} 条`}
                                showSizeChanger
                                onChange={(page, pageSize) => this.modalShowSizeChange(page, pageSize)}
                                onShowSizeChange={(page, pageSize) => {
                                    this.modalShowSizeChange(page, pageSize)
                                }}
                            />
                        </div> : ""}
                    <div style={{clear: 'both'}}/>
                </div>
            </Modal>
        )
    }

    //渲染筛选条件
    renderModalScreen() {
        return (
            <div style={{paddingBottom: 24, marginBottom: 24, borderBottom: '1px solid #ebebeb'}}>
                <div style={{float: 'left'}}>
                    <div style={{float: 'left'}}>
                        <div className={'ContenSecurityTitle'} style={{float: 'left'}}>检测内容:</div>
                        <Tooltip style={{width: 500}} placement="bottomLeft"
                                 title={this.state.resultContent}>
                            <div style={{
                                float: 'left',
                                width: 140,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                height: 45,
                                lineHeight: '45px'
                            }}>
                                {this.state.resultContent}
                            </div>
                        </Tooltip>
                    </div>

                    <div style={{float: 'left', display: "flex", alignItems: "center"}}>
                        <div className={'ContenSecurityTitle'} style={{float: 'left'}}>媒体类型</div>
                        <div style={{float: 'left', width: 140}} className={'ContenSecurityContent'}>
                            <Select
                                allowClear
                                value={this.state.mediaType ? this.state.mediaType : undefined}
                                style={{width: '100%'}}
                                placeholder={"请选择"}
                                onChange={(e) => {
                                    this.state.mediaType = e;
                                    this.listModalTypeChange();
                                }}>
                                {/*<Option value={-1}>请选择</Option>*/}
                                <Option value={2}>公众号</Option>
                                <Option value={3}>微博</Option>
                                <Option value={5}>抖音</Option>
                            </Select></div>
                    </div>
                    <div style={{float: 'left', display: "flex", alignItems: "center"}}>
                        <div className={'ContenSecurityTitle'} style={{float: 'left'}}>所属部门</div>
                        <div style={{float: 'left', width: 140}} className={'ContenSecurityContent'}>
                            <Select
                                allowClear
                                value={this.state.resultDepart ? this.state.resultDepart : undefined}
                                style={{width: '100%'}}
                                placeholder={"请选择部门"}
                                onChange={(e) => {
                                    this.state.resultDepart = e;
                                    this.listModalTypeChange();
                                }}>
                                {/*<Option value={-1}>请选择部门</Option>*/}
                                {this.state.departAllList.map((item, i) => {
                                    return (
                                        <Option key={i} value={item.id}>{item.name}</Option>
                                    )
                                })}
                            </Select></div>
                    </div>
                    <div style={{float: 'left',}} className={'ContenSecurityTitle'}>
                        <Button onClick={() => {
                            this.listModalRevert()
                        }} type="primary">重置</Button>
                    </div>

                </div>
                <div style={{clear: 'both'}}/>
            </div>
        )
    }

    //渲染检测报告
    renderDetectionReport() {

        let option = {
            title: {
                text: '',
                subtext: ''
            },
            tooltip: {
                trigger: 'axis'
            },
            calculable: true,
            xAxis: [
                {
                    type: 'category',
                    data: [],//x轴数据，
                    axisLabel: {
                        rotate: 20
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '危险数',
                    type: 'bar',
                    data: [],//y轴数据
                    label: {
                        show: true,
                        position: 'top'
                    },
                    barWidth: 30,
                    itemStyle: {
                        normal: {
                            color: '#0E77D1',
                            lineStyle: {
                                color: '#0E77D1'
                            }
                        }
                    }
                },

            ]
        };
        //苟宗统计图数据；
        this.state.reportData.forEach((item, i) => {
            option.xAxis[0].data.push(item.mediaName);
            option.series[0].data.push(item.totalCount);
        });

        //检测内容
        let sensitiveWord = '';
        this.state.record.checkWords && this.state.record.checkWords.length > 0 && this.state.record.checkWords.forEach((item, i) => {
            sensitiveWord = sensitiveWord + item + (i === this.state.record.checkWords.length - 1 ? '' : '、')
        });

        //检测范围
        let mediaNames = '';
        if (this.state.record.allMedia) {
            mediaNames = '全部单位-全部媒体';
        } else {
            this.state.record.mediaNames && this.state.record.mediaNames.length > 0 && this.state.record.mediaNames.forEach((item, i) => {
                mediaNames = mediaNames + item + (i === this.state.record.mediaNames.length - 1 ? '' : '、')
            });
        }
        //检测日期范围
        let dateFromTo = '';
        if (this.state.record.noLimitTime) {
            dateFromTo = '不限制';
        } else {
            dateFromTo = this.state.record.from && this.state.record.to ? utils.formatToDay(this.state.record.from) + ' ~ ' + utils.formatToDay(this.state.record.to) : ''
        }

        return (
            <Modal
                title="检测报告"
                visible={this.state.reportStatus}
                okText={'检测'}
                onOk={() => {
                }}
                onCancel={() => {
                    this.setState({reportStatus: false})
                }}
                footer={<div>
                </div>}
                width={800}
            >
                <div>
                    <style>{`.myMediaTitle{text-align: left;}`}</style>
                    <Row>
                        <Col span={12}>
                            <div className={'myMediaTitle'} style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap', paddingRight: 10
                            }}>检测内容：<span title={sensitiveWord}>{sensitiveWord}</span></div>
                        </Col>
                        <Col span={12}>
                            <div className={'myMediaTitle'} title={mediaNames} style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>检测范围：{mediaNames}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6}>
                            <div className={'myMediaTitle'}>总检测内容数：{this.state.record.totalCount}</div>
                        </Col>
                        <Col span={6}>
                            <div className={'myMediaTitle'}>危险内容数：{this.state.record.count}</div>
                        </Col>
                        <Col span={6}>
                            <div
                                className={'myMediaTitle'}>危险内容占比：{this.state.record.totalCount ? (this.state.record.count / this.state.record.totalCount * 100).toFixed(2) : 0}%
                            </div>
                        </Col>
                        <Col span={6}>
                            <div className={'myMediaTitle'}>危险数：{this.state.record.totalSensitiveWordCount}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <div
                                className={'myMediaTitle'}>检测时间：{this.state.record.checkTime ? utils.formatDate(this.state.record.checkTime) : ''}</div>
                        </Col>
                        <Col span={12}>
                            <div className={'myMediaTitle'}>检测日期范围：{dateFromTo}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <div className={'myMediaTitle'} style={{fontWeight: 500}}>含危险内容媒体top10</div>
                            <div style={{height: 400, padding: 10,}}>
                                <div style={{height: 380}}>
                                    <ReactEcharts
                                        option={option}
                                        notMerge={true}
                                        lazyUpdate={true}
                                        style={{width: '100%', height: '100%'}}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>

            </Modal>
        )
    }

    //------------列表操作---------

    //获取手动检测的列表
    getSensitiveCheckTaskListQuery() {
        let body = {
            page: this.state.page - 1,
            size: this.state.size,
            startDate: this.state.startDate ? this.state.startDate.format(' YYYY-MM-DD') + ' 00:00:00' : null,
            endDate: this.state.endDate ? this.state.endDate.format(dateFormat) + ' 23:59:59' : null,
            search: encodeURIComponent(this.state.searchText),
        };
        this.Action.getSensitiveCheckTaskListQuery(body, (data) => {
            let _data = data && data.data;
            let hideOnSinglePage = true;
            let totalElements = 0;
            let dataSource = [];
            if (_data && _data.content && _data.content.length) {
                dataSource = _data.content;
                totalElements = _data.totalElements;
                hideOnSinglePage = false;
            }
            this.setState({
                dataSource,
                totalElements,
                hideOnSinglePage
            }, () => {
                $('.ant-pagination-options-quick-jumper').find('input').val('')
            })
        })
    }

    //获取所有部门
    getDeptAll() {
        this.Action.getDeptAll((data) => {
            let departAllList = [];
            if(data && data.length){
                departAllList = data;
            }
            this.setState({
                departAllList
            })
        })
    }

    //根据部门获取媒体
    getMediaByDepart() {
        this.Action.getAllNewMediaTypeNoPage((mediaData) => {
            let children = JSON.parse(JSON.stringify(mediaData));
            let qbmtKey = "0";
            let mediaList = [
                {
                    title: '全部媒体',
                    value: qbmtKey,
                    key: qbmtKey,
                    children: children && children.length && children.map(media => {
                        media.title = media.name;
                        media.value = media.id;
                        media.key = media.id;
                        media.children = [];
                        return media;
                    })
                }
            ];
            let body = {
                mainDeptId: this.state.depart
            };
            this.Action.getAllMediaByDeptIdOrType(body, (_data) => {
                _data && _data.length && _data.forEach((item, i) => {
                    mediaList[0].children.forEach((Item, Index) => {
                        if (Item.key === item.newMediaTypeId) {
                            Item.children.push({
                                title: item.name,
                                value: item.code,
                                key: item.code,
                            })
                        }
                    });
                });
                this.state.media = qbmtKey;
                this.setState({mediaList: mediaList})
            })
        });
    }

    //重置
    revert() {
        this.state.page = 1;
        this.state.startDate = null;//开始时间
        this.state.endDate = null;//结束时间
        this.state.searchText = '';//搜索的文字
        this.getSensitiveCheckTaskListQuery();
    }


    //内容部分翻页
    paginationChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.getSensitiveCheckTaskListQuery();
    }


    //-------------点击开始检测之后操作-----------------

    //点击开始检测
    startDetection() {
        this.state.visible = true;
        this.testRevert();
    }

    //点击检测
    handleOk() {
        let checkedWords = [];
        if (this.state.content.length > 0) {
            let content = this.state.content.trim();//去除空格；
            if (content[content.length - 1] === '、') {
                content = content.substring(0, content.length - 1);//如果最后一位是顿号，删除最后一位
            }
            checkedWords = content.length > 0 ? content.trim().split('、') : [];
        }
        //检测输入内容
        if (!this.state.useThesaurus) {
            if (checkedWords.length === 0) {
                message.warn('请输入检测内容');
                return
            }
        }
        //检测选择部门
        if (!this.state.rangeStatus && !this.state.depart) {
            message.warn("请选择部门");
            return;
        }
        //检测输入时间
        if (!this.state.timeStatus) {
            if (!this.state.createsTartTime && !this.state.createsTartTime) {
                message.warn('请选择内容创建日期');
                return
            }
        }
        let mediaIdArr = [];
        this.state.mediaList[0].children.forEach(item => {
            mediaIdArr.push(item.key);
        })
        let mediaCodes = [];//媒体数组
        if (this.state.media === '0') {  //选中全部媒体，获取全部媒体下的所有媒体
            this.state.mediaList[0].children.forEach(Item => {
                Item.children.forEach((item => {
                    mediaCodes.push(item.key)
                }))
            })
        } else if (mediaIdArr.indexOf(this.state.media) > -1) {   //选中媒体平台层，获取该媒体平台下的所有媒体
            this.state.mediaList[0].children.forEach(Item => {
                if (Item.key === this.state.media) {
                    Item.children.forEach((item => {
                        mediaCodes.push(item.key)
                    }))
                }
            })
        } else {   //单独选中某个媒体
            mediaCodes.push(this.state.media)
        }
        //判断媒体
        if (!this.state.rangeStatus) {
            if (!mediaCodes.length) {
                message.error('此单位没有媒体');
                return
            }
        }

        let body = {
            "checkWords": this.state.useThesaurus ? [] : [
                ...checkedWords
            ],
            "mediaCodes": this.state.rangeStatus ? [] : [...mediaCodes],
            "systemDictionary": this.state.useThesaurus,
            "noLimitTime": this.state.timeStatus,
            "allMedia": this.state.rangeStatus,
            "startDate": this.state.timeStatus ? null : (this.state.createsTartTime ? this.state.createsTartTime.format('YYYY-MM-DD') + ' 00:00:00' : null),
            "endDate": this.state.timeStatus ? null : (this.state.createEndTime ? this.state.createEndTime.format('YYYY-MM-DD') + ' 23:59:59' : null),
        };
        this.Action.startContentSecurity(body, (data) => {
            this.testRevert()
            this.state.visible = false;
            this.getSensitiveCheckTaskListQuery();
        });

    }


    //检测入口的取消
    onCancel() {
        this.state.visible = false;
        this.testRevert();
    }

    //检测重置
    testRevert() {
        this.setState({
            content: '',//检测内容
            useThesaurus: false,//是否使用词库
            depart: undefined,//所属单位
            media: '0',//选择媒体
            rangeStatus: false,//是否使用范围
            createsTartTime: null,//开始时间
            createEndTime: null,//结束时间
            timeStatus: false,//是否限制时间
            resultDepart:0,
        });
    }

    //---------------点击某一行后弹出界面操作--------------


    //点击某一行
    onClickItem(record) {
        if (record.status !== '已完成') {
            message.warn('数据正在检索中！')
        } else {
            if (record.taskId) {
                this.state.taskId = record.taskId;
                let sensitiveWord = '';
                record.checkWords && record.checkWords.length > 0 && record.checkWords.forEach((item, i) => {
                    sensitiveWord = sensitiveWord + item + (i === record.checkWords.length - 1 ? '' : '、')
                });
                this.state.resultContent = sensitiveWord;
                this.state.record = record;//点击项所有数据
                this.state.resultPage = 1;
                this.state.resultSize = 10;
                this.state.mediaType = 0;//媒体类型
                this.state.resultDepart = 0;//检测结果的所属部门
                this.customSensitiveCheckListQuery()
            }
        }
    }

    //获取检测结果
    customSensitiveCheckListQuery() {
        let body = {
            taskId: this.state.taskId,
            page: this.state.resultPage - 1,
            size: this.state.resultSize,
            deptId: this.state.resultDepart ? this.state.resultDepart : -1,
            mediaType: this.state.mediaType ? this.state.mediaType : -1,
            statusName: this.state.releaseStatus,
        };
        this.Action.customSensitiveCheckListQuery(body, (data) => {
            let Data = data.data;
            if (Data.content) {
                this.setState({
                    resultList: Data.content,
                    resultTotalElements: Data.totalElements,
                    resultStatus: true,
                }, () => {
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                })
            }
        })
    }


    //检测结果弹出窗
    listModalTypeChange() {
        this.state.resultPage = 1;
        //this.setState({})
        this.customSensitiveCheckListQuery()
    }

    //检测结果筛选条件重置
    listModalRevert() {
        this.state.resultPage = 1;
        this.state.mediaType = 0;//媒体类型
        this.state.releaseStatus = 0;//发布状态
        this.state.resultDepart = 0;//检测结果的所属部门
        this.customSensitiveCheckListQuery();
    }

    //弹出框内容部分页码改变
    modalShowSizeChange(page, pageSize) {
        this.scrollRef.scrollToTop();
        this.state.resultPage = page;
        this.state.resultSize = pageSize;
        this.customSensitiveCheckListQuery();
    }

    //点击预览

    onClickItemReview(record) {
        let signWords = [];
        record.sensitiveWordList && record.sensitiveWordList.length > 0 && record.sensitiveWordList.forEach((item, i) => {
            signWords.push(item.oldStr)
        })

        let type = record.mediaType;
        if (type === 2) {
            //微信预览
            if (record && record.resourceId) {
                this.Action.getWechatDangerDetails(record.resourceId, (data) => {
                    let _data = data;
                    if (_data) {
                        let parms = {
                            title: _data.title,
                            summary: _data.summary,
                            content: _data.content,
                            titlePic: _data.titlePic,
                            author: _data.author,
                            updateDate: new Date(_data.statDate),
                            url: _data.link,
                            mediaName: _data.mediaName
                        };
                        this.WeChatReview.show('', '', signWords, parms)
                    } else {
                        message.error("该条数据已被删除,无法查看详情");
                    }

                });
            }
        } else if (type === 3) {
            if (record.resourceId) {
                //微博预览
                this.Action.getWeiBoDangerDetails(record.resourceId, (data) => {
                    let _data = data;
                    if (_data) {
                        let reviewParms = {
                            updateDate: utils.formatDate(_data.createdAt),//内容
                            content: _data.text,
                            picUrls: _data.picUrls,
                            publishUrl: _data.shareUrl
                        };
                        this.MicroBlogReview.show(reviewParms, signWords)
                    } else {
                        message.error("该条数据已被删除,无法查看详情");
                    }

                });
            }
        } else if (type === 5) {
            if (record.resourceId) {
                //抖音预览
                this.Action.getDouyinDangerDetails(record.resourceId, (data) => {
                    let _data = data;
                    if (_data) {
                        let reviewParms = {
                            title: _data.title,
                            titlePic: _data.cover,
                            updateDate: _data.collecTime,
                            author: _data.author,
                            videoUrl: _data.videoUrl,
                            videoShareUrl: _data.shareUrl
                        };
                        this.TiktokReview.show(reviewParms, signWords)
                    } else {
                        message.error("该条数据已被删除,无法查看详情");
                    }
                });
            }
        }
    }

    //点击检测报告
    detectionReport() {
        let body = {
            taskId: this.state.taskId
        };
        this.Action.getSensitiveMediaTop10(body, (data) => {
            let Data = data.data;
            if (Data && Data.length) {
                this.state.reportData = Data;
            } else {
                this.state.reportData = [];
            }
            this.setState({reportStatus: true})
        });
    }

    //检测结果导出表格
    exportExcel() {
        let url = this.Action.getContentSecurityexcelCustom + '/' + this.state.taskId;
        this.request({
            url, method: "downloadGet", contentType: 'json'
        });
    }

    //关闭
    resultCancel() {
        this.state.resultStatus = false;
        this.setState({})
    }

}